const DEFAULT_COLUMN_MAP = {
  xxl: 3,
  xl: 3,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1
};
export default DEFAULT_COLUMN_MAP;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/descriptions/constant.js
// module id = 3868
// module chunks = 0